<script setup>
import { Link } from '@inertiajs/vue3';
import { useI18n } from 'vue-i18n';

// Icons
import arrow from '@i/arrow-link.svg';
import envelope from '@i/envelope.svg';
import phoneIcon from '@i/phone.svg';

// Components
import Icon from '@/Components/Icon.vue';

const { t } = useI18n();

const props = defineProps({
    href: String,
    title: String,
    white: Boolean,
    linkTitle: String,
    job_position: String,
    phone: String,
    email: String,
    excerpt: [String, null],
});
</script>

<template>
    <Component
        :is="href ? Link : 'div'"
        :href="href"
        class="relative h-full"
    >
        <slot />

        <div
            class="flex flex-col justify-between p-6"
            :class="{ 'pb-14': href }"
        >
            <div :class="{ 'flex flex-col items-center': job_position }">
                <h2
                    v-if="title"
                    class="mb-0 text-xl"
                    :class="{ 'mb-1': job_position }"
                >
                    {{ title }}
                </h2>
                <p
                    v-if="excerpt"
                    class="mt-2"
                >
                    {{ excerpt }}
                </p>
                <span
                    v-if="job_position"
                    class="mb-3 text-gray-medium"
                > {{ job_position }} </span>
            </div>

            <div class="md:px-4">
                <div>
                    <div v-if="phone">
                        <div class="flex items-center gap-2">
                            <Icon
                                :icon="phoneIcon"
                                :icon-dutch="phoneIcon"
                                alt="phone icon"
                                class="h-auto w-4 shrink-0"
                            />
                            <a
                                :href="`tel:${phone}`"
                                class="hover:text-primary"
                            >{{ phone }}</a>
                        </div>
                    </div>

                    <div v-if="email">
                        <div class="flex items-center gap-2">
                            <Icon
                                :icon="envelope"
                                :icon-dutch="envelope"
                                alt="envelope icon"
                                class="h-auto w-5 shrink-0"
                            />
                            <a
                                :href="`mailto:${email}`"
                                class="hover:text-primary"
                            >{{ email }}</a>
                        </div>
                    </div>
                </div>
            </div>

            <div
                v-if="href"
                class="absolute bottom-5 flex flex-col items-start justify-between"
            >
                <div
                    class="flex items-start gap-2 font-bold md:gap-4"
                    :class="$slots ? 'mt-3' : ''"
                >
                    <img
                        :src="arrow"
                        class="mt-1 h-4 w-4 shrink-0 transition duration-200 ease-in-out group-hover:translate-x-1 md:h-4 md:w-4"
                        alt="icon"
                    >

                    <div v-if="linkTitle">
                        {{ linkTitle }}
                    </div>
                </div>
            </div>
        </div>
    </Component>
</template>
